import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Automation icon — connector between two nodes.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const AutomationIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M7.5 6C7.5 5.17157 6.82843 4.5 6 4.5C5.17157 4.5 4.5 5.17157 4.5 6C4.5 6.82843 5.17157 7.5 6 7.5C6.82843 7.5 7.5 6.82843 7.5 6ZM15.5 14C15.5 13.1716 14.8284 12.5 14 12.5C13.1716 12.5 12.5 13.1716 12.5 14C12.5 14.8284 13.1716 15.5 14 15.5C14.8284 15.5 15.5 14.8284 15.5 14ZM16.5 14C16.5 15.3807 15.3807 16.5 14 16.5C12.6193 16.5 11.5 15.3807 11.5 14C11.5 12.7905 12.3589 11.7814 13.5 11.5498V7.33301C13.4999 7.11211 13.4121 6.90034 13.2559 6.74414C13.0997 6.58794 12.8879 6.50009 12.667 6.5H10.667C10.3908 6.5 10.167 6.27614 10.167 6C10.167 5.72386 10.3908 5.5 10.667 5.5H12.667C13.1531 5.50009 13.6192 5.69337 13.9629 6.03711C14.3066 6.38085 14.4999 6.84689 14.5 7.33301V11.5498C15.6411 11.7814 16.5 12.7905 16.5 14ZM8.5 6C8.5 7.20943 7.64105 8.21753 6.5 8.44922V16C6.5 16.2761 6.27614 16.5 6 16.5C5.72386 16.5 5.5 16.2761 5.5 16V8.44922C4.35895 8.21753 3.5 7.20943 3.5 6C3.5 4.61929 4.61929 3.5 6 3.5C7.38071 3.5 8.5 4.61929 8.5 6Z"
      fill="currentColor"
    />
  </svg>
);

export default AutomationIcon;
